import { useState, lazy, Suspense } from 'react';
import { Menu } from 'lucide-react';

const MobileMenuSheet = lazy(() => import('@/components/MobileMenuSheet'));

export default function MobileMenu({ className = 'md:hidden' }) {
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  return (
    <>
      <button
        onClick={() => { setLoaded(true); setOpen(true); }}
        aria-label="Buka menu"
        data-testid="mobile-menu-btn"
        className={`${className} h-10 w-10 rounded-lg flex items-center justify-center text-zinc-700 hover:bg-zinc-100 active:bg-zinc-200 transition-colors`}
      >
        <Menu className="h-5 w-5" />
      </button>
      {loaded && (
        <Suspense fallback={null}>
          <MobileMenuSheet open={open} setOpen={setOpen} />
        </Suspense>
      )}
    </>
  );
}
